import { render, staticRenderFns } from "./Revenue.vue?vue&type=template&id=537673ba&scoped=true&"
import script from "./Revenue.vue?vue&type=script&lang=ts&"
export * from "./Revenue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537673ba",
  null
  
)

export default component.exports